<!-- 季后赛 8强 || 12强 -->
<template>
  <div
    class="basketball_team8OrTeam12"
    :class="[baseNum === 2 ? 'top8' : '', themeClass]"
  >
    <template v-if="cloMatcthList">
      <span
        v-for="(cloItem, cloIndex) in cloMatcthList"
        :key="cloIndex"
        :class="`clo${cloIndex - 0 + baseNum}`"
      >
        <template v-if="cloIndex - 0 + baseNum === 3">
          <!-- <span class="clo3_row">
            <span class="clo3_row_text" v-text="'总决赛'"></span>
            <span class="matchItem_box">
              <span class="matchItem_row"></span>
            </span>
          </span> -->
          <span
            class="clo3_row"
            v-for="(matchItem, matchIndex) in cloItem"
            :key="matchIndex"
          >
            <span class="clo3_row_text" v-text="'总决赛'"></span>
            <span class="matchItem_box">
              <span class="matchItem_row">
                <span class="leftArea">
                  <span
                    class="leftArea_row"
                    v-for="(teamItem, homeAwayIndex) in matchItem.teamArr"
                    :key="homeAwayIndex"
                  >
                    <span class="leftArea_row_teamLogo">
                      <img v-if="teamItem.teamLogo" :src="teamItem.teamLogo" />
                      <i
                        v-else-if="!teamItem.teamLogo && teamItem.teamNameScore"
                      ></i>
                    </span>
                    <span
                      class="leftArea_row_scoreTeamName"
                      :class="teamItem.isWin ? 'win' : ''"
                      v-text="teamItem.teamNameScore"
                      @click="goDetail(teamItem)"
                    ></span>
                  </span>
                </span>
                <span class="rightArea">
                  <span
                    class="rightArea_val"
                    v-text="matchItem.homeScore"
                  ></span>
                  <span
                    class="rightArea_vs"
                    v-if="matchItem.homeScore && matchItem.awayScore"
                    v-text="'|'"
                  ></span>
                  <span
                    class="rightArea_val"
                    v-text="matchItem.awayScore"
                  ></span>
                </span>
              </span>
            </span>
          </span>
        </template>
        <template v-else>
          <span
            class="clo_row"
            v-for="(matchItem, matchIndex) in cloItem"
            :key="matchIndex"
          >
            <span class="matchItem_box">
              <span class="matchItem_row">
                <span class="leftArea">
                  <span
                    class="leftArea_row"
                    v-for="(teamItem, homeAwayIndex) in matchItem.teamArr"
                    :key="homeAwayIndex"
                  >
                    <span class="leftArea_row_teamLogo">
                      <img v-if="teamItem.teamLogo" :src="teamItem.teamLogo" />
                      <i
                        v-else-if="!teamItem.teamLogo && teamItem.teamNameScore"
                      ></i>
                    </span>
                    <span
                      class="leftArea_row_scoreTeamName"
                      :class="[
                        teamItem.isWin ? 'win' : '',
                        teamItem.teamId ? '' : 'notHover',
                      ]"
                      v-text="teamItem.teamNameScore"
                      @click="goDetail(teamItem)"
                    ></span>
                  </span>
                </span>
                <span class="rightArea">
                  <span
                    class="rightArea_val"
                    v-text="matchItem.homeScore"
                  ></span>
                  <span
                    class="rightArea_vs"
                    v-if="matchItem.homeScore && matchItem.awayScore"
                    v-text="'|'"
                  ></span>
                  <span
                    class="rightArea_val"
                    v-text="matchItem.awayScore"
                  ></span>
                </span>
              </span>
            </span>
          </span>
        </template>
        <!-- <span class="clo1_row">
          <span class="matchItem_box">
            <span class="matchItem_row"></span>
          </span>
        </span> -->
      </span>
    </template>
    <!-- <span class="clo2">
      <span class="clo2_row">
        <span class="matchItem_box">
          <span class="matchItem_row"></span>
        </span>
      </span>
      <span class="clo2_row">
        <span class="matchItem_box">
          <span class="matchItem_row"></span>
        </span>
      </span>
      <span class="clo2_row">
        <span class="matchItem_box">
          <span class="matchItem_row"></span>
        </span>
      </span>
    </span>
    <span class="clo3">
      <span class="clo3_row">
        <span class="clo3_row_text" v-text="'总决赛'"></span>
        <span class="matchItem_box">
          <span class="matchItem_row"></span>
        </span>
      </span>
    </span>
    <span class="clo4">
      <span class="clo2_row">
        <span class="matchItem_box">
          <span class="matchItem_row"></span>
        </span>
      </span>
      <span class="clo2_row">
        <span class="matchItem_box">
          <span class="matchItem_row"></span>
        </span>
      </span>
      <span class="clo2_row">
        <span class="matchItem_box">
          <span class="matchItem_row"></span>
        </span>
      </span>
    </span>
    <span class="clo5">
      <span class="clo1_row">
        <span class="matchItem_box">
          <span class="matchItem_row"></span>
        </span>
      </span>
      <span class="clo1_row">
        <span class="matchItem_box">
          <span class="matchItem_row"></span>
        </span>
      </span>
    </span> -->
  </div>
</template>

<script>
export default {
  name: 'basketball_team8OrTeam12',
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataType: '',
          dataList: [],
        },
        // data: {
        //   dataType: 'top12',
        //   dataList: [],
        // },
        statisticsModels: [],
      }),
    },
    themeClass: {
      type: String,
      default: '', // 'onlyDisplay'
    },
    detailPathName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      baseNum: 1, //top12:1；top8:2
      cloMatcthList: null,
    }
  },
  watch: {
    datas(newVal, oldVal) {
      console.debug('basketball_team8OrTeam12:', newVal, oldVal)
      if (
        newVal &&
        JSON.stringify(newVal.data && newVal.data.dataList) !==
          JSON.stringify(
            oldVal && oldVal.data && oldVal.data.dataList
              ? oldVal.data.dataList
              : null
          )
      ) {
        this.computedMatchList(newVal.data)
      }
    },
    immediate: false,
    deep: true,
  },
  created() {
    if (this.datas) {
      this.computedMatchList(this.datas.data)
    }
  },
  methods: {
    computedMatchList(dataObj) {
      if (!dataObj) {
        this.cloMatcthList = null
        return
      }
      let dataType = ''
      let orginData = JSON.parse(JSON.stringify(dataObj.dataList))
      if (orginData && orginData.length === 4) {
        dataType = 'top12'
      } else if (orginData && orginData.length === 3) {
        dataType = 'top8'
      }
      let cloMatcthList = []
      if (orginData.length > 0 && dataType) {
        orginData.forEach((phaseItem) => {
          if (phaseItem.matches && phaseItem.matches.length > 0) {
            phaseItem.matches.forEach((matchItem) => {
              // let matchWinner = ''
              // if (!matchItem.matchWinner) {
              //   // 没有比赛结果时的逻辑，前端判断
              //   if (matchItem.homeScore && matchItem.awayScore) {
              //     // 比分都是字符串
              //     if (matchItem.homeScore - matchItem.awayScore > 0) {
              //       matchWinner = 'home'
              //     } else if (matchItem.homeScore - matchItem.awayScore < 0) {
              //       matchWinner = 'away'
              //     }
              //   } else {
              //   }
              // }
              matchItem.teamArr = []
              // 有球队名字则显示球队，没有球队名字时存在2种，一种待定，一种压根就不存在这支球队（比如说7只球队打，少一支球队）所以不显示球队和默认logo
              matchItem.teamArr.push({
                teamLogo: matchItem.homeLogo,
                teamNameScore: matchItem.homeName
                  ? `${matchItem.homeRank ? matchItem.homeRank : ''} ${
                      matchItem.homeName
                    }`
                  : matchItem.matchWinner
                  ? ''
                  : '待定',
                isWin: matchItem.matchWinner === 'home',
                teamId: matchItem.homeId,
              })
              matchItem.teamArr.push({
                teamLogo: matchItem.awayLogo,
                teamNameScore: matchItem.awayName
                  ? `${matchItem.awayRank ? matchItem.awayRank : ''} ${
                      matchItem.awayName
                    }`
                  : matchItem.matchWinner
                  ? ''
                  : '待定',
                isWin: matchItem.matchWinner === 'away',
                teamId: matchItem.awayId,
              })
            })
          }
        })
        if (dataType === 'top12') {
          this.baseNum = 1
          cloMatcthList[0] = [orginData[0].matches[0], orginData[0].matches[1]] //clo1:[0,1]
          cloMatcthList[1] = [
            orginData[1].matches[0],
            orginData[2].matches[0],
            orginData[1].matches[1],
          ]
          cloMatcthList[2] = [orginData[3].matches[0]]
          cloMatcthList[3] = [
            orginData[1].matches[2],
            orginData[2].matches[1],
            orginData[1].matches[3],
          ]
          cloMatcthList[4] = [orginData[0].matches[2], orginData[0].matches[3]] //clo5:[2,3]
        } else if (dataType === 'top8') {
          this.baseNum = 2
          cloMatcthList[0] = [
            orginData[0].matches[0],
            orginData[1].matches[0],
            orginData[0].matches[1],
          ]
          cloMatcthList[1] = [orginData[2].matches[0]]
          cloMatcthList[2] = [
            orginData[0].matches[2],
            orginData[1].matches[1],
            orginData[0].matches[3],
          ]
        }
      } else {
        cloMatcthList = null
      }
      console.debug('cloMatcthList:', cloMatcthList)
      this.cloMatcthList = cloMatcthList
    },
    goDetail(item) {
      if (!this.detailPathName || !item.teamId) return
      let params = {
        tid: item.teamId,
      }
      console.debug('this.detailPathName:', this.detailPathName)
      this.openNewWeb(this.$router, `${this.detailPathName}`, params)
    },
  },
}
</script>

<style lang="scss" scoped>
.basketball_team8OrTeam12 {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  justify-content: center;
  padding: 5.33vw 0;
  &.top8 {
    .clo2 {
      &:first-child,
      &:nth-child(3) {
        .matchItem_box {
          left: -2.5vw;
        }
      }
    }
    .clo4 {
      &:first-child,
      &:nth-child(3) {
        .matchItem_box {
          right: -2.5vw;
        }
      }
    }
    .clo3 {
      width: calc(30% + 2.5vw);
      padding: 0 5%;
    }
  }

  .clo1,
  .clo2,
  .clo3,
  .clo4,
  .clo5 {
    width: 20%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
  }

  .clo1,
  .clo5 {
    width: calc(20% - 1.25vw);
    height: calc(31.52vw + 8.333vw - 1px - 1px - 1px);
    justify-content: space-between;

    .clo_row {
      position: relative;
      width: 100%;
      height: 8.333vw;

      &::before {
        content: '\20';
        position: absolute;
        bottom: 0;
        z-index: 2;
        width: 50%;
        height: 1px;
        background-color: var(--mixtmt_mainColor0);
      }

      &::after {
        content: '\20';
        position: absolute;
        top: 50%;
        z-index: 2;
        width: 1px;
        height: 8.333vw;
        background-color: var(--mixtmt_mainColor0);
        transform: translateY(-50%);
      }
    }

    .matchItem_box {
      top: 50%;
    }
  }

  .clo1 {
    .clo_row {
      &::before {
        right: 0;
        content: '\20';
      }

      &::after {
        right: 0;
      }
    }

    .matchItem_box {
      padding: 0 1.25vw 0 0;
      left: 0;
    }
  }

  .clo5 {
    .clo_row {
      &::before {
        left: 0;
        content: '\20';
      }

      &::after {
        left: 0;
      }
    }

    .matchItem_box {
      padding: 0 0 0 1.25vw;
      right: 0;
    }
  }

  .clo2,
  .clo4 {
    justify-content: flex-start;
    height: calc(31.52vw - 1px - 1px);
    background-color: var(--mixtmt_whiteColor);
    border: 1px solid var(--mixtmt_mainColor0);
    .clo_row {
      position: relative;
      width: 100%;
      height: 8.333vw;

      &:first-child {
        margin-top: -4.165vw;

        .matchItem_box {
          top: 0;
        }
      }

      &:nth-child(2) {
        height: 23.187vw;
        .matchItem_box {
          top: 50%;
          transform: translateY(-50%);
        }
      }

      &:nth-child(3) {
        margin-bottom: -4.165vw;

        .matchItem_box {
          bottom: 0;
        }
      }
    }
  }

  .clo2 {
    border-left: 0;

    .clo_row {
      &:nth-child(2) {
        .matchItem_box {
          left: 2.083vw;
        }
      }
    }

    .matchItem_box {
      left: 0;
    }
  }

  .clo4 {
    border-right: 0;

    .clo_row {
      &:nth-child(2) {
        .matchItem_box {
          right: 2.083vw;
        }
      }
    }

    .matchItem_box {
      right: 0;
    }
  }

  .clo3 {
    position: relative;
    justify-content: center;
    align-items: flex-start;
    width: calc(20% + 2.5vw);
    height: calc(31.52vw - 1px - 1px);
    &::before {
      position: absolute;
      content: '\20';
      left: 0;
      top: 50%;
      z-index: 2;
      width: 100%;
      height: 1px;
      background-color: var(--mixtmt_mainColor0);
      transform: translateY(-50%);
    }
    .clo3_row {
      position: relative;
      width: 100%;
      height: 13.88vw;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;

      .clo3_row_text {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100%;
        font-size: 1.388vw;
        font-weight: bold;
        color: var(--mixtmt_mainColor0);
        text-align: center;
      }
    }

    .matchItem_box {
      padding: 0 2.5vw;
      left: 0;
    }
  }

  .matchItem_box {
    position: absolute;
    z-index: 50;
    width: 100%;
    height: 8.333vw;
    padding: 0 1.25vw;

    .matchItem_row {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;
      background-color: var(--mixtmt_whiteColor);
      border: 1px solid var(--mixtmt_greyColor7);
      border-radius: 0.555vw;
      overflow: hidden;

      .leftArea {
        width: calc(100% - 3.2vw);
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .leftArea_row {
          width: 100%;
          height: 3.8vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          padding: 0 0.347vw;

          .leftArea_row_teamLogo {
            width: 2.083vw;
            height: 2.083vw;
            overflow: hidden;

            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
            i {
              display: block;
              width: 100%;
              height: 100%;
              background-image: var(--mixtmt_default_teamLogo);
              background-size: 100% 100%;
              background-size: contain;
              background-repeat: no-repeat;
            }
          }

          .leftArea_row_scoreTeamName {
            width: calc(100% - 2.083vw);
            padding-left: 0.347vw;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 0.833vw;
            font-weight: bold;
            color: var(--mixtmt_greyColor3);

            &.win {
              color: var(--mixtmt_subColor1_1);
            }
          }
        }
      }

      .rightArea {
        width: 3.2vw;
        height: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: var(--mixtmt_subColor_main);
        color: var(--mixtmt_greyColor3);

        .rightArea_val {
          font-size: 1.25vw;
          line-height: 2.083vw;
          text-align: center;
          font-weight: bold;
        }

        .rightArea_vs {
          font-size: 0.833vw;
          line-height: 2.083vw;
          text-align: center;
        }
      }
    }
  }
}

.mixtmt_pc .basketball_team8OrTeam12 {
  &:not(.onlyDisplay) {
    .matchItem_box {
      .matchItem_row {
        &:hover {
          cursor: default;
          background-color: var(--mixtmt_mainColor2);
          border: 1px solid var(--mixtmt_mainColor0);

          .rightArea {
            background-color: var(--mixtmt_mainColor0);
            color: var(--mixtmt_whiteColor);
          }
        }
        .leftArea_row_scoreTeamName {
          &:not(.notHover):hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
